module.exports = __webpack_public_path__ + "img/BFHP.f4cded2b.png";